import { render, staticRenderFns } from "./client.vue?vue&type=template&id=226488f2&scoped=true&"
import script from "./client.vue?vue&type=script&lang=ts&"
export * from "./client.vue?vue&type=script&lang=ts&"
import style0 from "./client.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./client.vue?vue&type=style&index=1&id=226488f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226488f2",
  null
  
)

export default component.exports